module.exports = __webpack_public_path__ + "img/ma236.f425f072.png";